import { render } from "./CodeRenderer.vue?vue&type=template&id=106c8753&scoped=true"
import script from "./CodeRenderer.vue?vue&type=script&lang=js"
export * from "./CodeRenderer.vue?vue&type=script&lang=js"

import "./CodeRenderer.vue?vue&type=style&index=0&id=106c8753&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106c8753"]])

export default __exports__